import { baseColors } from "@Constants/baseStyles"
import * as React from "react"
import Svg, { G, Path, Defs, ClipPath } from "react-native-svg"

const SvgStetoscope = (props) => {
    return (
        <Svg xmlns="http://www.w3.org/2000/svg" width={61} height={70} fill="none" viewBox="0 0 61 70" {...props}>
            <G clipPath="url(#clip0)">
                <Path
                    fill="#fff"
                    d="M2.38 32.688H.294V8.465C.293 4.07 3.881.521 8.253.521v2.051c-3.23 0-5.872 2.637-5.872 5.893v24.223z"
                />
                <Path
                    fill="#fff"
                    d="M6.067 3.549L4.795.716C5.905.26 7.08 0 8.253 0v3.093c-.75 0-1.5.163-2.186.456zm28.576 29.237h-2.055V8.596a5.897 5.897 0 00-5.904-5.894V.62c4.403 0 7.959 3.581 7.959 7.944v24.223z"
                />
                <Path
                    fill="#fff"
                    d="M28.805 3.646a5.36 5.36 0 00-2.12-.423V.098a8.51 8.51 0 013.36.683l-1.24 2.865zM27.922 70c-6.458 0-11.678-5.242-11.678-11.656v-10.94h-2.38C6.425 47.405.39 41.382.39 33.959V23.344h1.924v10.614c0 6.349 5.187 11.526 11.548 11.526h7.144c6.36 0 11.547-5.177 11.547-11.526V23.344h1.925v10.614c0 7.423-6.035 13.447-13.472 13.447h-2.838v10.94c0 5.371 4.371 9.734 9.753 9.734h1.794c5.383 0 9.754-4.363 9.754-9.735V24.81h.065v-1.335c0-3.94 3.197-7.13 7.144-7.13h1.044c3.947 0 7.144 3.19 7.144 7.13v21.098h-1.925V23.474c0-2.865-2.349-5.209-5.219-5.209h-1.044c-2.87 0-5.22 2.344-5.22 5.21V42.65h-.064v15.693C41.395 64.791 36.143 70 29.716 70h-1.794z"
                />
                <Path
                    fill="#fff"
                    d="M54.052 56.977c3.82 0 6.916-3.09 6.916-6.903 0-3.812-3.097-6.902-6.916-6.902-3.82 0-6.916 3.09-6.916 6.902 0 3.813 3.097 6.903 6.916 6.903z"
                />
                <Path
                    fill={baseColors.green.dark}
                    d="M57.412 50.074c0 1.856-1.5 3.354-3.36 3.354a3.352 3.352 0 01-3.36-3.354c0-1.855 1.5-3.353 3.36-3.353 1.86.033 3.36 1.53 3.36 3.353zm-38.883 8.27V47.795h2.446c7.633 0 13.864-6.186 13.864-13.837V22.953h-2.675v11.005c0 6.154-5.024 11.135-11.156 11.135h-7.144c-6.165 0-11.156-5.014-11.156-11.135V22.953H0v11.005c0 7.619 6.198 13.837 13.864 13.837h2.022v10.777h2.675c0-.065-.032-.163-.032-.228z"
                />
            </G>
            <Defs>
                <ClipPath id="clip0">
                    <Path fill="#fff" d="M0 0h61v70H0z" />
                </ClipPath>
            </Defs>
        </Svg>
    )
}

export default SvgStetoscope
